export const contentIsShorterThanMax = (
  descriptionParagraphs: string[],
  maxVisibleDescriptionWords: number
) => {
  if (descriptionParagraphs.length !== 1) {
    return false;
  }
  const words = descriptionParagraphs[0]?.split(" ") ?? [];
  return words.length <= maxVisibleDescriptionWords;
};
